<template>
    <div class="tpv-domicilios">
  
      <!-- =====================================================
           HEADER
      ====================================================== -->
      <div class="domicilios-header">
       
        
      </div>
      <div class="domicilios-header-left">
          <div class="domicilios-header-icon">
            <v-icon>mdi-motorbike</v-icon>
          </div>
  
          <div>
            <div class="domicilios-title">
              Domicilios
            </div>
  
            <div class="domicilios-subtitle">
              Órdenes listas para salida
            </div>
          </div>
        </div>
  
        <div class="domicilios-header-right">
  
          <div class="domicilios-counter">
            <strong>{{ ordenesMostradas.length }}</strong>

<span>
  {{ mostrandoSalidas ? 'en salida' : 'pendientes' }}
</span>
          </div>
  
        </div>
        <v-btn
  text
  small
  class="btn-regresar"
  @click="$emit('cerrar')"
>
  <v-icon left small>
    mdi-arrow-left
  </v-icon>
  Regresar
</v-btn>

<v-btn
  text
  small
  class="btn-regresar"
  @click="cambiarVistaEstatus"
>
  <v-icon left small>
    {{ mostrandoSalidas ? 'mdi-motorbike-off' : 'mdi-motorbike' }}
  </v-icon>

  {{ mostrandoSalidas ? 'Pendientes' : 'En salida' }}
</v-btn>

<!-- =====================================================
     SELECCIONAR REPARTIDOR
====================================================== -->
<div class="repartidor-toolbar">
  <div class="repartidor-toolbar-label">
    <div class="repartidor-toolbar-icon">
      <v-icon small>mdi-motorbike</v-icon>
    </div>

    <div>
      <div class="repartidor-toolbar-title">
        Repartidor
      </div>

      <div class="repartidor-toolbar-subtitle">
        Selecciona el repartidor para la salida
      </div>
    </div>
  </div>

  <select
    v-model="repartidorSeleccionado"
    class="repartidor-select"
  >
    <option :value="null" disabled>
      Selecciona un repartidor...
    </option>

    <option
      v-for="r in repartidores"
      :key="r.intEmpleado"
      :value="r.intEmpleado"
    >
      {{ r.strNombreCompleto }}
    </option>
  </select>

  <div
  v-if="ordenesSeleccionadas.length"
  class="seleccion-counter"
>
  <strong>{{ ordenesSeleccionadas.length }}</strong>
  <span>seleccionadas</span>
</div>

 <!-- Salida Repas: solo en pendientes -->
<v-btn
  v-if="!mostrandoSalidas"
  class="btn-salida"
  @click="saleRepa"
>
  <v-icon left>mdi-motorbike</v-icon>
  Salida Repas
</v-btn>

<!-- Pago: solo en salidas -->
<v-btn
  v-else
  class="btn-salida"
  @click="pagoOrdenes"
>
  <v-icon left>mdi-cash-check</v-icon>
  Pago
</v-btn>
<div>
  <v-btn
  v-if="ordenesMostradas.length"
  text
  small
  class="btn-regresar"
  @click="seleccionarTodas"
>
  <v-icon left small>
    mdi-checkbox-multiple-marked-outline
  </v-icon>

  {{ todasSeleccionadas ? 'Deseleccionar todas' : 'Seleccionar todas' }}
</v-btn>
</div>


</div>
  
      <!-- =====================================================
           CONTENIDO
      ====================================================== -->
      <div class="domicilios-content">
  
        <!-- SIN ORDENES -->
        <div
  v-if="!ordenesMostradas.length"
  class="domicilios-empty"
>
  <div class="empty-icon">
    <v-icon>
      {{ mostrandoSalidas ? 'mdi-motorbike-off' : 'mdi-motorbike-off' }}
    </v-icon>
  </div>

  <div class="empty-title">
    {{ mostrandoSalidas
      ? 'No hay domicilios en salida'
      : 'No hay domicilios pendientes'
    }}
  </div>

  <div class="empty-subtitle">
    {{ mostrandoSalidas
      ? 'Las órdenes que ya tienen salida aparecerán aquí.'
      : 'Las órdenes listas para salida aparecerán aquí.'
    }}
  </div>
</div>
  
  
        <!-- ORDENES -->
        <div
          v-else
          class="domicilios-grid"
        >
  
          <div
            v-for="orden in ordenesMostradas"
            :key="orden.intPOSEnc"
            class="domicilio-card"
            :class="{
  'domicilio-card-selected': estaSeleccionada(orden)
}"
            @click="seleccionarOrden(orden)"
          >
  
            <!-- ---------------------------------------------
                 PARTE SUPERIOR
            ---------------------------------------------- -->
            <div class="domicilio-card-top">
  
              <div>
                <div class="orden-number">
                  #{{ orden.intOrden }}
                </div>
  
                <div class="orden-time">
                  {{ orden.hora || '12:35 PM' }}
                </div>
              </div>
  
              <!-- <div class="orden-status">
                <span class="status-dot"></span>
                Lista
              </div> -->
  
            </div>
  
  
            <!-- ---------------------------------------------
                 CLIENTE
            ---------------------------------------------- -->
            <div class="cliente-section">
  
              <div class="cliente-icon">
                <v-icon>mdi-account-outline</v-icon>
              </div>
  
              <div class="cliente-info">
  
                <div class="cliente-name">
                  {{ orden.cliente.strNombre || 'Cliente domicilio' }}
                </div>
  
                <div
                  v-if="orden.telefono"
                  class="cliente-phone"
                >
                  <v-icon small>mdi-phone-outline</v-icon>
                  {{ orden.telefono }}
                </div>
  
              </div>
  
            </div>
  
  
            <!-- ---------------------------------------------
                 DIRECCION
            ---------------------------------------------- -->
            <div class="direccion-section">
  
              <div class="direccion-icon">
                <v-icon>mdi-map-marker-outline</v-icon>
              </div>
  
              <div class="direccion-info">
  
                <div class="direccion-label">
                  DIRECCIÓN
                </div>
  
                <div class="direccion-text">
                  {{"Direccion: " + orden.cliente.strDireccion || 'Sin dirección registrada' }} <br>
                  {{"Colonia: " + orden.cliente.strColonia || 'Sin dirección registrada' }}<br>
                  {{"Telefono: " + orden.cliente.strTelefono || 'Sin dirección registrada' }}<br>
                </div>
  
              </div>
  
            </div>
  
  
            <!-- ---------------------------------------------
                 SEPARADOR
            ---------------------------------------------- -->
            <div class="card-divider"></div>
  
  
            <!-- ---------------------------------------------
                 INFORMACION DE PAGO
            ---------------------------------------------- -->
            <div class="orden-info">
  
              <div class="info-item">
  
                <span class="info-label">
                  Total
                </span>
  
                <strong class="info-value total">
                  ${{ formatMoney(orden.dblTotal) }}
                </strong>
  
              </div>
  
              <!-- <div class="info-item">
  
                <span class="info-label">
                  Pago
                </span>
  
                <strong class="info-value">
                  {{ orden.formaPago || 'Pendiente' }}
                </strong>
  
              </div> -->
  
            </div>
  
  
            
            

          </div>
  
        </div>
  
      </div>
      
    </div>
    
  </template>
  
  
  <script>

// import {
//   Toast,
//   ErrorWeb,
// } from "../controllers/DataController.js";
import axios from 'axios';
import {
  POSEncFunctions,

} from "../controllers/POSController.js";
import {
  Data
} from "../controllers/DataController.js";
  export default {
  
    name: 'OrdenesDomicilio',
  
    props: {
      ordenes: {
        type: Array,
        default: function () {
          return []
        }
      },
      repartidores: { type: Array, default: () => [] }
    },
  
    data: function () {
      return {
        ordenesSeleccionadas: [],
        repartidorSeleccionado: null,
        mostrandoSalidas: false,
        ordenFunctions: new POSEncFunctions(),
        impresoras: [],
        dataController: new Data()
      }
    },
    computed: {

ordenesMostradas: function () {

  return this.ordenes.filter(function (orden) {

    // ==========================================
    // PENDIENTES
    // ==========================================
    if (!this.mostrandoSalidas) {
      return Number(orden.intEstatus) === 2
    }

    // ==========================================
    // EN SALIDA
    // Solo mostrar las del repartidor seleccionado
    // ==========================================
    return (
      Number(orden.intEstatus) === 3 &&
      this.repartidorSeleccionado !== null &&
      Number(orden.intEmpleado) === Number(this.repartidorSeleccionado)
    )

  }.bind(this))
},

todasSeleccionadas: function () {

  return (
    this.ordenesMostradas.length > 0 &&
    this.ordenesSeleccionadas.length === this.ordenesMostradas.length
  )
}

},
watch: {

repartidorSeleccionado: function () {

  this.ordenesSeleccionadas = []

  this.$emit('seleccionar', [])
},

ordenes: {
  immediate: true,
  deep: true,

  handler: function (nuevasOrdenes) {

    console.log('ORDENES QUE RECIBIO DOMICILIOS:', nuevasOrdenes)

  }
},

repartidores: {
  immediate: true,
  deep: true,

  handler: function (nuevosRepartidores) {

    console.log('repas QUE RECIBIO DOMICILIOS:', nuevosRepartidores)

  }
}
},
    async mounted() {
      
    },
    methods: {
  
      seleccionarOrden: function (orden) {

var index = this.ordenesSeleccionadas.findIndex(function (x) {
  return x.intPOSEnc === orden.intPOSEnc
})

if (index === -1) {
  this.ordenesSeleccionadas.push(orden)
} else {
  this.ordenesSeleccionadas.splice(index, 1)
}

console.log('ORDENES SELECCIONADAS:', this.ordenesSeleccionadas)

this.$emit('seleccionar', this.ordenesSeleccionadas)
},
estaSeleccionada: function (orden) {
  return this.ordenesSeleccionadas.some(function (x) {
    return x.intPOSEnc === orden.intPOSEnc
  })
},
seleccionarTodas: function () {

if (this.ordenesSeleccionadas.length === this.ordenesMostradas.length) {

  this.ordenesSeleccionadas = []

} else {

  this.ordenesSeleccionadas = this.ordenesMostradas.slice()

}

this.$emit('seleccionar', this.ordenesSeleccionadas)
},
cambiarVistaEstatus: function () {

this.mostrandoSalidas = !this.mostrandoSalidas

// Limpiar selección al cambiar de vista
this.ordenesSeleccionadas = []

this.repartidorSeleccionado = null

this.$emit('seleccionar', [])

},

async pagoOrdenes() {

if (!this.ordenesSeleccionadas.length) {
  this.$toast.error('Favor de seleccionar al menos una orden')
  return
}

// Buscar repartidor seleccionado
var repartidor = this.repartidores.find(
  function (x) {
    return Number(x.intEmpleado) === Number(this.repartidorSeleccionado)
  }.bind(this)
)

if (!repartidor) {
  this.$toast.error('Favor de seleccionar un repartidor')
  return
}
this.impresoras = await this.dataController.loadImpresoras();

var impresora = this.impresoras[0];

if (!impresora) {
  this.$toast.error('No se encontró ninguna impresora')
  return
}
var datosTicket = {
  physical_printer: {
    address: impresora.address,
    port: impresora.port
  },
  ordenes: this.ordenesSeleccionadas,
  nombreRepartidor: repartidor.strNombreCompleto
}
  var urlPrinter = 'http://localhost/PRINT'
console.log('DATOS PARA TICKET:', datosTicket)

try {

  await axios.post(
    urlPrinter + '/POSPrinter/TicketSalidaRepartidor',
    datosTicket
  )
  console.log('Ticket enviado correctamente')



  // Continuar con tu proceso de pago
  this.$emit(
    'pagoOrdenes',
    this.ordenesSeleccionadas
  )

} catch (error) {

  console.error(
    'Error al imprimir ticket de salida:',
    error
  )

  this.$toast.error(
    'No se pudo imprimir el ticket de salida'
  )
}
},

async saleRepa() {

// Validar órdenes
if (!this.ordenesSeleccionadas.length) {
  this.$toast.error('Favor de seleccionar al menos una orden')
  return
}

// Validar repartidor
if (!this.repartidorSeleccionado) {
  this.$toast.error('Favor de asignar repartidor')
  return
}

// Buscar repartidor
var repartidor = this.repartidores.find(
  function (x) {
    return x.intEmpleado == this.repartidorSeleccionado
  }.bind(this)
)

if (!repartidor) {
  this.$toast.error('No se encontró el repartidor seleccionado')
  return
}

var salida = {
  intEmpleado: repartidor.intEmpleado,
  strRepartidor: repartidor.strNombreCompleto,
  ordenes: this.ordenesSeleccionadas
}

console.log('SALIDA MASIVA:', salida)

// Avisar al componente padre
this.$emit('saleRepa', salida)
},
  
      darSalida: function (orden) {
  
        this.ordenSeleccionada = orden
  
        this.$emit('dar-salida', orden)
      },
  
      formatMoney: function (value) {
  
        var numero = Number(value || 0)
  
        return numero.toLocaleString('es-MX', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }
  
    }

    
  
  }
  </script>
  
  
  <style scoped>
  
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
  
  
  /* ==========================================================
     VARIABLES
  ========================================================== */
  
  .tpv-domicilios {
  
    --tpv-primary: #113e75;
    --tpv-primary-hover: #0c2b52;
    --tpv-primary-light: #58789e;
    --tpv-primary-tint: #e9eef4;
  
    --tpv-secondary: #b97823;
    --tpv-success: #fe9000;
  
    --tpv-bg: #f4f5f7;
    --tpv-surface: #ffffff;
    --tpv-alt: #fafbfc;
  
    --tpv-border: #e2e4e8;
    --tpv-border-strong: #c7cbd1;
  
    --tpv-text: #1a1d23;
    --tpv-muted: #6b7280;
  
    min-height: 100%;
    width: 100%;
  
    background: var(--tpv-bg);
  
    color: var(--tpv-text);
  
    font-family: 'Inter', sans-serif;
  
    box-sizing: border-box;
  }
  
  
  /* ==========================================================
     HEADER
  ========================================================== */
  
  .domicilios-header {
  
    min-height: 72px;
  
    display: flex;
    align-items: center;
    justify-content: space-between;
  
    padding: 14px 20px;
  
    background: var(--tpv-surface);
  
    border-bottom: 1px solid var(--tpv-border);
  }
  
  
  .domicilios-header-left {
  
    display: flex;
    align-items: center;
  
    gap: 12px;
  }
  
  
  .domicilios-header-icon {
  
    width: 42px;
    height: 42px;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    border-radius: 11px;
  
    background: var(--tpv-primary-tint);
  
    color: var(--tpv-primary);
  }
  
  
  .domicilios-header-icon .v-icon {
  
    color: var(--tpv-primary);
  }
  
  
  .domicilios-title {
  
    font-size: 19px;
  
    line-height: 22px;
  
    font-weight: 800;
  
    letter-spacing: -0.3px;
  }
  
  
  .domicilios-subtitle {
  
    margin-top: 2px;
  
    font-size: 12px;
  
    font-weight: 500;
  
    color: var(--tpv-muted);
  }
  
  
  .domicilios-header-right {
  
    display: flex;
    align-items: center;
  
    gap: 10px;
  }
  
  
  .domicilios-counter {
  
    display: flex;
    align-items: baseline;
  
    gap: 5px;
  
    padding: 8px 12px;
  
    border-radius: 9px;
  
    background: var(--tpv-primary-tint);
  
    color: var(--tpv-primary);
  }
  
  
  .domicilios-counter strong {
  
    font-size: 17px;
  
    font-weight: 800;
  }
  
  
  .domicilios-counter span {
  
    font-size: 11px;
  
    font-weight: 600;
  }
  
  
  .domicilios-refresh {
  
    color: var(--tpv-primary) !important;
  
    background: transparent !important;
  }
  
  
  /* ==========================================================
     CONTENT
  ========================================================== */
  
  .domicilios-content {
  
    padding: 18px;
  
    box-sizing: border-box;
  }
  
  
  .domicilios-grid {
  
    display: grid;
  
    grid-template-columns:
      repeat(auto-fill, minmax(290px, 1fr));
  
    gap: 14px;
  
    align-items: start;
  }
  
  
  /* ==========================================================
     CARD
  ========================================================== */
  
  .domicilio-card {
  
    position: relative;
  
    padding: 16px;
  
    background: var(--tpv-surface);
  
    border: 1px solid var(--tpv-border);
  
    border-radius: 14px;
  
    cursor: pointer;
  
    transition:
      border-color .16s ease,
      box-shadow .16s ease,
      transform .16s ease;
  
    box-sizing: border-box;
  }
  
  
  .domicilio-card:hover {
  
    border-color: var(--tpv-border-strong);
  
    box-shadow:
      0 5px 16px rgba(17, 62, 117, .08);
  
    transform: translateY(-1px);
  }
  
  
  .domicilio-card-selected {
  
    border: 2px solid var(--tpv-primary);
  
    padding: 15px;
  
    box-shadow:
      0 6px 20px rgba(17, 62, 117, .12);
  }
  
  
  .domicilio-card-selected::before {
  
    content: '';
  
    position: absolute;
  
    left: 0;
    top: 14px;
    bottom: 14px;
  
    width: 3px;
  
    border-radius: 0 4px 4px 0;
  
    background: var(--tpv-primary);
  }
  
  
  /* ==========================================================
     CARD TOP
  ========================================================== */
  
  .domicilio-card-top {
  
    display: flex;
  
    align-items: flex-start;
  
    justify-content: space-between;
  
    gap: 10px;
  
    margin-bottom: 15px;
  }
  
  
  .orden-number {
  
    font-size: 19px;
  
    font-weight: 800;
  
    line-height: 21px;
  
    color: var(--tpv-text);
  }
  
  
  .orden-time {
  
    margin-top: 3px;
  
    font-size: 11px;
  
    font-weight: 500;
  
    color: var(--tpv-muted);
  }
  
  
  .orden-status {
  
    display: inline-flex;
  
    align-items: center;
  
    gap: 6px;
  
    padding: 5px 8px;
  
    border-radius: 7px;
  
    background: #fff4e6;
  
    color: #b96800;
  
    font-size: 10px;
  
    font-weight: 700;
  
    text-transform: uppercase;
  
    letter-spacing: .3px;
  }
  
  
  .status-dot {
  
    width: 6px;
    height: 6px;
  
    border-radius: 50%;
  
    background: var(--tpv-success);
  }
  
  
  /* ==========================================================
     CLIENTE
  ========================================================== */
  
  .cliente-section {
  
    display: flex;
  
    align-items: center;
  
    gap: 10px;
  
    margin-bottom: 14px;
  }
  
  
  .cliente-icon {
  
    width: 34px;
    height: 34px;
  
    flex: 0 0 34px;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    border-radius: 9px;
  
    background: #f1f3f5;
  }
  
  
  .cliente-icon .v-icon {
  
    color: var(--tpv-primary-light);
  }
  
  
  .cliente-name {
  
    font-size: 14px;
  
    font-weight: 700;
  
    line-height: 18px;
  
    color: var(--tpv-text);
  }
  
  
  .cliente-phone {
  
    display: flex;
  
    align-items: center;
  
    gap: 4px;
  
    margin-top: 2px;
  
    font-size: 11px;
  
    color: var(--tpv-muted);
  }
  
  
  .cliente-phone .v-icon {
  
    color: var(--tpv-muted);
  }
  
  
  /* ==========================================================
     DIRECCION
  ========================================================== */
  
  .direccion-section {
  
    display: flex;
  
    align-items: flex-start;
  
    gap: 10px;
  
    padding: 11px;
  
    border-radius: 9px;
  
    background: var(--tpv-alt);
  
    border: 1px solid #eef0f2;
  }
  
  
  .direccion-icon {
  
    width: 25px;
    height: 25px;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    flex: 0 0 25px;
  }
  
  
  .direccion-icon .v-icon {
  
    color: var(--tpv-primary);
  }
  
  
  .direccion-info {
  
    min-width: 0;
  }
  
  
  .direccion-label {
  
    margin-bottom: 3px;
  
    font-size: 9px;
  
    font-weight: 700;
  
    color: var(--tpv-muted);
  
    letter-spacing: .6px;
  }
  
  
  .direccion-text {
  
    font-size: 12px;
  
    line-height: 17px;
  
    font-weight: 500;
  
    color: var(--tpv-text);
  
    word-break: break-word;
  }
  
  
  /* ==========================================================
     DIVIDER
  ========================================================== */
  
  .card-divider {
  
    height: 1px;
  
    margin: 14px 0;
  
    background: var(--tpv-border);
  }
  
  
  /* ==========================================================
     INFO
  ========================================================== */
  
  .orden-info {
  
    display: grid;
  
    grid-template-columns: 1fr 1fr;
  
    gap: 12px;
  
    margin-bottom: 14px;
  }
  
  
  .info-item {
  
    display: flex;
  
    flex-direction: column;
  
    gap: 3px;
  }
  
  
  .info-label {
  
    font-size: 10px;
  
    font-weight: 600;
  
    color: var(--tpv-muted);
  }
  
  
  .info-value {
  
    font-size: 13px;
  
    font-weight: 700;
  
    color: var(--tpv-text);
  }
  
  
  .info-value.total {
  
    font-size: 17px;
  
    color: var(--tpv-primary);
  }
  
  
  /* ==========================================================
     BOTON SALIDA
  ========================================================== */
  
  .btn-salida {
  
    height: 42px !important;
  
    border-radius: 9px !important;
  
    background: var(--tpv-primary) !important;
  
    color: #ffffff !important;
  
    font-family: 'Inter', sans-serif !important;
  
    font-size: 11px !important;
  
    font-weight: 800 !important;
  
    letter-spacing: .4px;
  
    transition:
      background .16s ease,
      transform .16s ease;
  }
  
  
  .btn-salida:hover {
  
    background: var(--tpv-primary-hover) !important;
  
    transform: translateY(-1px);
  }
  
  
  .btn-salida .v-icon {
  
    color: #ffffff !important;
  }
  
  
  /* ==========================================================
     EMPTY
  ========================================================== */
  
  .domicilios-empty {
  
    min-height: 360px;
  
    display: flex;
  
    flex-direction: column;
  
    align-items: center;
  
    justify-content: center;
  
    text-align: center;
  }
  
  
  .empty-icon {
  
    width: 64px;
    height: 64px;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    margin-bottom: 15px;
  
    border-radius: 16px;
  
    background: var(--tpv-primary-tint);
  }
  
  
  .empty-icon .v-icon {
  
    font-size: 32px;
  
    color: var(--tpv-primary);
  }
  
  
  .empty-title {
  
    font-size: 16px;
  
    font-weight: 700;
  }
  
  
  .empty-subtitle {
  
    margin-top: 5px;
  
    max-width: 320px;
  
    font-size: 12px;
  
    line-height: 18px;
  
    color: var(--tpv-muted);
  }
  
  
  /* ==========================================================
     RESPONSIVE
  ========================================================== */
  
  @media (max-width: 700px) {
  
    .domicilios-header {
  
      padding: 12px 14px;
    }
  
    .domicilios-content {
  
      padding: 12px;
    }
  
    .domicilios-grid {
  
      grid-template-columns: 1fr;
  
      gap: 10px;
    }
  
  }
  
  
  @media (max-width: 420px) {
  
    .domicilios-title {
  
      font-size: 17px;
    }
  
    .domicilios-subtitle {
  
      display: none;
    }
  
    .domicilios-counter span {
  
      display: none;
    }
  
    .domicilios-content {
  
      padding: 10px;
    }
  
  }
  .repartidor-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  margin: 16px 18px 0;
  padding: 12px 14px;

  background: var(--tpv-surface);
  border: 1px solid var(--tpv-border);
  border-radius: 10px;
}

.repartidor-toolbar-label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.repartidor-toolbar-icon {
  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;
  background: var(--tpv-primary-tint);
}

.repartidor-toolbar-icon .v-icon {
  color: var(--tpv-primary);
}

.repartidor-toolbar-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--tpv-text);
}

.repartidor-toolbar-subtitle {
  margin-top: 2px;
  font-size: 10px;
  color: var(--tpv-muted);
}

.repartidor-select {
  width: 280px;
  height: 38px;

  padding: 0 10px;

  border: 1px solid var(--tpv-border-strong);
  border-radius: 8px;

  background: #ffffff;
  color: var(--tpv-text);

  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 600;

  outline: none;
  cursor: pointer;
}

.repartidor-select:focus {
  border-color: var(--tpv-primary);
  box-shadow: 0 0 0 2px rgba(17, 62, 117, .10);
}

@media (max-width: 700px) {
  .repartidor-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .repartidor-select {
    width: 100%;
  }
}
  
  </style>